module.exports = __webpack_public_path__ + "static/media/awfxcg32_1305.d482704f.ico";